import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class Permission extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
